module.exports = __webpack_public_path__ + "static/media/pushLogo.33ed5be8.svg";